/* eslint-disable no-redeclare */
class KtznEventStoreSubscriptionServiceError extends Error {
  /** Error type */
  type: KtznEventStoreSubscriptionServiceError.Type;

  constructor(
    type: KtznEventStoreSubscriptionServiceError.Type = KtznEventStoreSubscriptionServiceError.Type.general,
    ...params: any[]
  ) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...params);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, KtznEventStoreSubscriptionServiceError);
    }

    this.name = "KtznEventStoreSubscriptionServiceError";
    // Custom debugging information
    this.type = type;
  }
}

namespace KtznEventStoreSubscriptionServiceError {
  export enum Type {
    general = "General error",
    noCurrentUser = "No current user",
    noUserAccessId = "No userAccessId",
    startFailed = "startWebsocketConnection failed",
    authFailed = "Authentication failed",
    subscribeToConversationFailed = "subscribeToConversation failed",
    subscribeToConversationsFailed = "subscribeToConversations failed",
    subscribeToTenantFailed = "subscribeToTenant failed",
    subscribeToUserFailed = "subscribeToUser failed",
    unsubscribeFromAllEventsFailed = "unsubscribeFromAllEvents failed",
    stopFailed = "stopWebsocketConnection failed",
    unknownAction = "Unknown Vuex action",
  }
}

export default KtznEventStoreSubscriptionServiceError;
